import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColorSwatch: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconColorSwatch"><Path fillRule="evenodd" clipRule="evenodd" d="M2 2H13V2.93297L19.5118 6.69257L19.0454 7.50041L22.8055 14.013L10.6258 21.026C9.7382 21.6402 8.66112 22 7.5 22C4.46243 22 2 19.5376 2 16.5V2ZM13.5253 17.0616L20.0734 13.281L17.8907 9.50041L13.5253 17.0616ZM16.7798 7.42462L13 5.24237V13.9714L16.7798 7.42462ZM6 16.5C6 15.6716 6.67157 15 7.5 15C8.32843 15 9 15.6716 9 16.5C9 17.3284 8.32843 18 7.5 18C6.67157 18 6 17.3284 6 16.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColorSwatch;
